<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>
            TITLE.TITLE_CHANGE_PASSWORD
        </h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid">
        <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
        <div class="form-group">
           <input class="form-control" type="password"  placeholder="{{'LBL.OLD_PASSWORD' | translate}}" [(ngModel)]="Model.OldPassword" name="OldPassword" id="OldPassword">
        </div>
        <div class="form-group">
            <input class="form-control" type="password" placeholder="{{'LBL.NEW_PASSWORD' | translate}}" [(ngModel)]="Model.NewPassword" name="NewPassword" id="NewPassword">
        </div>
        <div class="form-group">
            <input class="form-control" type="password" placeholder="{{'LBL.CONFIRM_PASSWORD' | translate}}" [(ngModel)]="Model.ConfirmPassword" name="ConfirmPassword" id="ConfirmPassword">
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="DisableModalOpenEvent = false;OnSubmit()" translate>BTN.BTN_SUBMIT</button>
        <button type="button" class="btn btn-secondary" (click)="DisableModalOpenEvent = false; c('close')" translate>BTN.BTN_CLOSE</button>
    </div>

</ng-template>
